package org.multiplatform.kotfolio.pages.kids.maths

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.core.Page
import kotlinx.browser.document
import kotlinx.collections.immutable.persistentListOf
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Table
import org.jetbrains.compose.web.dom.Tbody
import org.jetbrains.compose.web.dom.Td
import org.jetbrains.compose.web.dom.Th
import org.jetbrains.compose.web.dom.Thead
import org.jetbrains.compose.web.dom.Tr
import org.jetbrains.compose.web.dom.Text
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("ordinal_number")
@Composable
fun MathOrdinalNumberPage() {
    LaunchedEffect(Unit) {
        val style = document.createElement("style")
        style.textContent = """
            @keyframes adminRowIn {
                from { opacity: 0; transform: translateX(-6px); }
                to   { opacity: 1; transform: translateX(0); }
            }
        """.trimIndent()
        document.head?.appendChild(style)
    }

    BlogLayout(
        PageProperties(
            "Ordinal Number",
            ""
        ),
        BlogProperties("Math", "Ordinal Number")
    ) {
        val ordinalList = persistentListOf(
            Number(
                cardinal = 1,
                cardinalWords = "One",
                ordinalWords = "First",
                ordinal = "1st"
            ),

            Number(
                cardinal = 2,
                cardinalWords = "Two",
                ordinalWords = "Second",
                ordinal = "2nd"
            ),

            Number(
                cardinal = 3,
                cardinalWords = "Three",
                ordinalWords = "Third",
                ordinal = "3rd"
            ),

            Number(
                cardinal = 4,
                cardinalWords = "Four",
                ordinalWords = "Fourth",
                ordinal = "4th"
            ),

            Number(
                cardinal = 5,
                cardinalWords = "Five",
                ordinalWords = "Fifth",
                ordinal = "5th"
            ),

            Number(
                cardinal = 6,
                cardinalWords = "Six",
                ordinalWords = "Sixth",
                ordinal = "6th"
            ),

            Number(
                cardinal = 7,
                cardinalWords = "Seven",
                ordinalWords = "Seventh",
                ordinal = "7th"
            ),

            Number(
                cardinal = 8,
                cardinalWords = "Eigth",
                ordinalWords = "Eighth",
                ordinal = "8th"
            ),

            Number(
                cardinal = 9,
                cardinalWords = "Nine",
                ordinalWords = "Ninth",
                ordinal = "9th"
            ),

            Number(
                cardinal = 10,
                cardinalWords = "Ten",
                ordinalWords = "Tenth",
                ordinal = "10th"
            ),

            Number(
                cardinal = 11,
                cardinalWords = "Eleven",
                ordinalWords = "Eleventh",
                ordinal = "11th"
            ),

            Number(
                cardinal = 12,
                cardinalWords = "Twelve",
                ordinalWords = "Twelfth",
                ordinal = "12th"
            ),

            Number(
                cardinal = 13,
                cardinalWords = "Thirteen",
                ordinalWords = "Thirteenth",
                ordinal = "13th"
            ),

            Number(
                cardinal = 14,
                cardinalWords = "Fourteen",
                ordinalWords = "Fourteenth",
                ordinal = "14th"
            ),

            Number(
                cardinal = 15,
                cardinalWords = "Fifteen",
                ordinalWords = "Fifteenth",
                ordinal = "15th"
            ),

            Number(
                cardinal = 16,
                cardinalWords = "Sixteen",
                ordinalWords = "Sixteenth",
                ordinal = "16th"
            ),

            Number(
                cardinal = 17,
                cardinalWords = "Seventeen",
                ordinalWords = "Seventeenth",
                ordinal = "17th"
            ),

            Number(
                cardinal = 18,
                cardinalWords = "Eighteen",
                ordinalWords = "Eighteenth",
                ordinal = "18th"
            ),

            Number(
                cardinal = 19,
                cardinalWords = "Nineteen",
                ordinalWords = "Nineteenth",
                ordinal = "19th"
            ),

            Number(
                cardinal = 20,
                cardinalWords = "Twenty",
                ordinalWords = "Twentieth",
                ordinal = "20th"
            ),
        )

        Column(
            modifier = Modifier.fillMaxWidth(),
            horizontalAlignment = Alignment.Start
        ) {

            Div({
                style {
                    property("overflow-x", "auto")
                    property("width", "100%")
                    property("max-width", "100vw") // Explicitly constrain to viewport width
                    property("display", "block")
                    property("-webkit-overflow-scrolling", "touch") // Smooth scroll for iOS
                }
            }) {
                Table({
                    style {
                        property("width", "100%")
                        property("border-collapse", "collapse")
                        property("font-size", "15px")
                        property("min-width", "1000px")
                    }
                }) {
                    Thead {
                        Tr({
                            style {
                                property("border-bottom", "2px solid #eee")
                            }
                        }) {
                            listOf(
                                "Cardinal Number",
                                "Cardinal Number in Words",
                                "Ordinal Number in Words",
                                "Ordinal Number",
                            ).forEach { header ->
                                Th({
                                    style {
                                        property("padding", "11px 16px")
                                        property("text-align", "left")
                                        property("font-size", "16px")
                                        property("font-weight", "700")
                                        property("text-transform", "uppercase")
                                        property("letter-spacing", "0.06em")
                                        property("color", "#000000")
                                        property(
                                            "white-space", "nowrap"
                                        )
                                    }
                                }) { Text(header) }
                            }
                        }
                    }

                    Tbody {
                        ordinalList.forEachIndexed { index, result ->
                            val rowDelay = "${(index * 0.04).coerceAtMost(0.4)}s"

                            Tr({
                                style {
                                    property("border-bottom", "1px solid #eee")
                                    if (index % 2 == 0) property(
                                        "background",
                                        "rgba(0,0,0,0.012)"
                                    )
                                    property("animation", "adminRowIn 0.3s ease $rowDelay both")
                                }
                            }) {
                                TCell("${result.cardinal}")
                                TCell(result.cardinalWords)
                                TCell(result.ordinalWords)
                                TCell(result.ordinal)
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun TCell(
    value: String,
    bold: Boolean = false,
    green: Boolean = false,
    red: Boolean = false,
    mono: Boolean = false,
    wrap: Boolean = false,
) {
    Td({
        style {
            property("padding", "13px 16px")
            if (wrap) {
                property("white-space", "normal")
                property("min-width", "300px")
            } else {
                property("white-space", "nowrap")
            }
            when {
                green -> { property("color", "#10b981"); property("font-weight", "600") }
                red   -> { property("color", "#ef4444"); property("font-weight", "600") }
                bold  -> property("font-weight", "600")
            }
            if (mono) property("font-family", "ui-monospace, monospace")
        }
    }) { Text(value) }
}


data class Number(
    val cardinal: Int = 0,
    val cardinalWords: String = "",
    val ordinalWords: String = "",
    val ordinal: String = "",
)

//https://byjus.com/maths/ordinal-numbers/